import type { NetworkViewModel } from '@trinnvis/dabih-api-client';
import type { ComputerViewModelExtended } from './computer-view-model-extended';
import { t } from 'src/i18n';

export function alertsForNetwork(
  c: NetworkViewModel & { computers: ComputerViewModelExtended[]; alerts: string[] },
): string[] {
  const warnings: string[] = [];
  let hasPersonalData = false;
  let hasMedicalData = false;
  let computerInheritsSystemUpdateOperatorType = false;
  let computerInheritsAntiVirusOperatorType = false;
  for (const item of c.computers) {
    if (item.systemUpdateOperatorType === 'INHERIT') {
      computerInheritsSystemUpdateOperatorType = true;
    }
    if (item.antiVirusOperatorType === 'INHERIT') {
      computerInheritsAntiVirusOperatorType = true;
    }
    if (item.personalDataItems && item.personalDataItems.length > 0) {
      hasPersonalData = true;
      for (const element of item.personalDataItems) {
        if (element.type === 'medicalRecords' || element.type === 'medicalEquipmentRecords') {
          hasMedicalData = true;
        }
      }
    }
  }
  if (hasMedicalData && c.connectionType !== 'NHN' && c.connectionType !== 'NHNotherISP') {
    // warnings.push('Nettverk som lagrer pasientdata skal bare ha internetttilkobling gjennom Norsk helsenett');
  }
  if (hasPersonalData) {
    if (
      (c.systemUpdateOperatorType === 'NONE' || c.systemUpdateOperatorType === 'UNDEFINED') &&
      computerInheritsSystemUpdateOperatorType
    ) {
      warnings.push(t('computers.alertSystemUpdateOperationUndefined'));
    }
    if (
      (c.systemUpdateOperatorType === 'external' || c.systemUpdateOperatorType === 'internalAndExternal') &&
      (!c.systemUpdateOperator || c.systemUpdateOperator.length < 1)
    ) {
      warnings.push(t('computers.alertSystemUpdateSupplierUndefined'));
    }
    if (
      (c.antiVirusOperatorType === 'NONE' || c.antiVirusOperatorType === 'UNDEFINED') &&
      computerInheritsAntiVirusOperatorType
    ) {
      warnings.push(t('computers.alertAntiVirusOperationUndefined'));
    }

    if (
      (c.antiVirusOperatorType === 'external' || c.antiVirusOperatorType === 'internalAndExternal') &&
      (!c.antiVirusOperator || c.antiVirusOperator.length < 1)
    ) {
      warnings.push(t('computers.alertAntiVirusOperatorUndefined'));
    }
  }
  return warnings;
}
